import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './WorkspaceCom.css';
import Button from '../Components/Common/Button';
import { useTheme } from '../ThemeContext';

const WorkspaceCom = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const dropdownRef = useRef(null);
  
  const [formData, setFormData] = useState({ 
    name: 'Finance', 
    industry: 'Artificial Intelligence & ML', 
    dept: 'Finance' 
  });
  
  const [isOpen, setIsOpen] = useState(false);

  const industries = [
    "Artificial Intelligence & ML", "Generative AI Services", "Renewable Energy & CleanTech",
    "Fintech & Digital Banking", "EdTech & Remote Learning", "HealthTech & Telemedicine",
    "Cybersecurity & Data Privacy", "E-commerce & D2C", "Cloud Computing & SaaS",
    "Blockchain & Web3", "Autonomous Vehicles & Logistics", "Space Technology",
    "BioTechnology", "Quantum Computing", "Robotics & Automation",
    "Digital Marketing & AdTech", "Media & Entertainment", "Sustainable Agriculture",
    "Smart City Infrastructure", "Venture Capital & Private Equity"
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCreateWorkspace = (e) => {
    e.preventDefault();
    // Passing EVERYTHING to the next page
    navigate('/workspace-invite', { 
      state: { 
        workspaceName: formData.name,
        industry: formData.industry,
        department: formData.dept 
      } 
    });
  };

  const selectIndustry = (val) => {
    setFormData({ ...formData, industry: val });
    setIsOpen(false);
  };

  return (
    <div className="workspace-wrapper">
     <div className="workspace-card text-center" style={{ 
  backgroundColor: '#F5F5F5',   // ← fix
  color: 'var(--text-main)',
  borderColor: 'var(--border-color)'
}}>
        <div className="logo-section">
          <img src="/images/kinenew.svg" alt="KINEXAR" className="title-img" style={{ filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none' }} />
        </div>
<h2 className="workspace-header"><strong>Set up Your Workspace</strong></h2>
        <div className="form-container mx-auto">
          <div className="text-start mb-4">
            <label className="workspace-label">Workspace Team*</label>
            <div className="d-flex gap-3">
              <div className="selection-box d-flex align-items-center p-3" onClick={() => navigate('/workspace')} style={{ cursor: 'pointer' }}>
                <img src="/images/indinew.svg" alt="Individual" className="option-icon me-2" />
                <div className="text-start flex-grow-1">
                  <div className="option-title">Individual</div>
                  <div className="option-subtitle">Personal Account</div>
                </div>
              </div>
              <div className="selection-box d-flex align-items-center p-3 active">
                <img src="/images/conew.svg" alt="Company" className="option-icon me-2" />
                <div className="text-start flex-grow-1">
                  <div className="option-title">Company</div>
                  <div className="option-subtitle">Team Account</div>
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={handleCreateWorkspace}>
            <div className="text-start mb-2">
              <label className="workspace-label">Workspace Name*</label>
              <input type="text" className="form-control custom-input" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
            </div>

            <div className="text-start mb-2 position-relative" ref={dropdownRef}>
              <label className="workspace-label">Industry</label>
              <div className="custom-dropdown-header" onClick={() => setIsOpen(!isOpen)}>
                {formData.industry}
                <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}></span>
              </div>
              {isOpen && (
                <div className="custom-dropdown-list">
                  {industries.map((item, index) => (
                    <div key={index} className="custom-dropdown-item" onClick={() => selectIndustry(item)}>{item}</div>
                  ))}
                </div>
              )}
            </div>

            <div className="text-start mb-4">
              <label className="workspace-label">Department</label>
              <input type="text" className="form-control custom-input" value={formData.dept} onChange={(e) => setFormData({...formData, dept: e.target.value})} required />
            </div>

            <Button type="submit" className="w-100">Create Workspace</Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceCom;